/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralTriggerType } from './ReferralTriggerType';
import {
    ReferralTriggerTypeFromJSON,
    ReferralTriggerTypeFromJSONTyped,
    ReferralTriggerTypeToJSON,
    ReferralTriggerTypeToJSONTyped,
} from './ReferralTriggerType';

/**
 * 
 * @export
 * @interface ActiveReferralProgramResponse
 */
export interface ActiveReferralProgramResponse {
    /**
     * True when a non-disabled, non-hidden, non-expired ReferralRewardThreshold exists. When false, the SPA shows a paused / coming-soon empty state.
     * @type {boolean}
     * @memberof ActiveReferralProgramResponse
     */
    active: boolean;
    /**
     * Admin-authored trigger label (e.g. "Level 5"). Omitted when active is false.
     * @type {string}
     * @memberof ActiveReferralProgramResponse
     */
    triggerCopy?: string;
    /**
     * Admin-authored reward label shown to the referrer (e.g. "$20 in FUEL").
     * @type {string}
     * @memberof ActiveReferralProgramResponse
     */
    rewardCopy?: string;
    /**
     * Admin-authored fine-print disclaimer line.
     * @type {string}
     * @memberof ActiveReferralProgramResponse
     */
    qualifierCopy?: string;
    /**
     * 
     * @type {ReferralTriggerType}
     * @memberof ActiveReferralProgramResponse
     */
    triggerType?: ReferralTriggerType;
    /**
     * Numeric trigger argument (e.g. 5 for LEVEL_REACHED).
     * @type {number}
     * @memberof ActiveReferralProgramResponse
     */
    triggerValue?: number;
    /**
     * Raw USD reward amount on the active threshold. Exposed for fallback rendering when rewardCopy is empty.
     * @type {number}
     * @memberof ActiveReferralProgramResponse
     */
    amountUsd?: number;
}



/**
 * Check if a given object implements the ActiveReferralProgramResponse interface.
 */
export function instanceOfActiveReferralProgramResponse(value: object): value is ActiveReferralProgramResponse {
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function ActiveReferralProgramResponseFromJSON(json: any): ActiveReferralProgramResponse {
    return ActiveReferralProgramResponseFromJSONTyped(json, false);
}

export function ActiveReferralProgramResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveReferralProgramResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'],
        'triggerCopy': json['triggerCopy'] == null ? undefined : json['triggerCopy'],
        'rewardCopy': json['rewardCopy'] == null ? undefined : json['rewardCopy'],
        'qualifierCopy': json['qualifierCopy'] == null ? undefined : json['qualifierCopy'],
        'triggerType': json['triggerType'] == null ? undefined : ReferralTriggerTypeFromJSON(json['triggerType']),
        'triggerValue': json['triggerValue'] == null ? undefined : json['triggerValue'],
        'amountUsd': json['amountUsd'] == null ? undefined : json['amountUsd'],
    };
}

export function ActiveReferralProgramResponseToJSON(json: any): ActiveReferralProgramResponse {
    return ActiveReferralProgramResponseToJSONTyped(json, false);
}

export function ActiveReferralProgramResponseToJSONTyped(value?: ActiveReferralProgramResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'triggerCopy': value['triggerCopy'],
        'rewardCopy': value['rewardCopy'],
        'qualifierCopy': value['qualifierCopy'],
        'triggerType': ReferralTriggerTypeToJSON(value['triggerType']),
        'triggerValue': value['triggerValue'],
        'amountUsd': value['amountUsd'],
    };
}

